export const scaleRegion = (region, scale) => {
  switch (region.figure) {
    case 'rect':
      return {
        ...region,
        x: Math.round(region.x * scale),
        y: Math.round(region.y * scale),
        width: Math.round(region.width * scale),
        height: Math.round(region.height * scale),
      };
    case 'polygon':
      return {
        ...region,
        coords: region.coords.map(({ x, y }) => ({
          x: Math.round(x * scale),
          y: Math.round(y * scale),
        })),
      };
    default:
      return region;
  }
};

export const unscaleRegion = (region, scale) => {
  switch (region.figure) {
    case 'rect':
      return {
        ...region,
        x: Math.floor(region.x / scale),
        y: Math.floor(region.y / scale),
        width: Math.floor(region.width / scale),
        height: Math.floor(region.height / scale),
      };
    case 'polygon':
      return {
        ...region,
        coords: region.coords.map(({ x, y }) => ({
          x: Math.floor(x / scale),
          y: Math.floor(y / scale),
        })),
      };
    default:
      return region;
  }
};

export const convertRegionFromPercentToAbs = ({
  x, y, width, height,
}, mediaSize) => {
  return {
    x: Math.round((x / 100) * mediaSize.width),
    y: Math.round((y / 100) * mediaSize.height),
    width: Math.round((width / 100) * mediaSize.width),
    height: Math.round((height / 100) * mediaSize.height),
  };
};

export const convertRegionFromAbsToPercent = ({
  x, y, width, height,
}, mediaSize) => {
  return {
    x: +((x / mediaSize.width) * 100).toFixed(2),
    y: +((y / mediaSize.height) * 100).toFixed(2),
    width: +((width / mediaSize.width) * 100).toFixed(2),
    height: +((height / mediaSize.height) * 100).toFixed(2),
  };
};

export const roundCoordinates = ({
  x, y, width, height,
}) => {
  return {
    x: Math.round(x),
    y: Math.round(y),
    width: Math.round(width),
    height: Math.round(height),
  };
};
